import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: PartnerLogo__container;
    display: flex;
    flex-direction: column;
    margin-bottom: ${spacing.XXS};
    justify-content: center;

    ${mq(Breakpoints.DESKTOP)} {
      display: block;
      margin-bottom: ${spacing.XL};
    }
  `,
  text: css`
    label: PartnerLogo__text;
    margin-bottom: var(--spacing-XXS);
    color: ${colours.font.PLACEHOLDER_GRAY};
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: ${fonts.size.XS};
    line-height: ${fonts.lineHeight.BASE};
    text-align: center;

    ${mq(Breakpoints.DESKTOP)} {
      max-width: 100%;
      margin-right: 0;
      padding-bottom: ${spacing.XXS};
      font-size: ${fonts.size.L};
      text-align: left;
    }
  `,
  imageContainer: css`
    label: PartnerLogo__imageContainer;
    display: flex;
    justify-content: center;
    min-width: 13rem;
    max-height: 5rem;
    flex: 0 1 0;
    margin: 0 auto;
    ${mq(Breakpoints.DESKTOP)} {
      justify-content: flex-start;
      max-width: 100%;
      max-height: initial;
    }
  `,
  image: css`
    label: PartnerLogo__image;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    ${mq(Breakpoints.DESKTOP)} {
      max-height: initial;
    }
  `,
};

export default styles;
